export default __webpack_public_path__ + "static/media/css.aeb0a9dc.svg";